import React, { useState } from "react";
import "../../faq.scss";
import FlowTransition from "components/FlowTransition/FlowTransition";
import { FlowTrasitionParamsType } from "components/FlowTransition/types";
import MobileFirstPage from "../MobileFirstPage/MobileFirstPage";
import { FaqContainerType } from "./types";
import FaqTab from "pages/Home/components/Faq/components/FaqTab/FaqTab";
import OperateTab from "../OperateTab/OperateTab";

const Faq = ({
  initialQuestion,
  initialSection,
  initialSubSection,
}: FaqContainerType) => {
  const PAGES = {
    Initial: "Initial",
    Account: "Account",
    Slots: "Slots",
    Trips: "Trips",
    Operate: "Operate",
    Earnings: "Earnings",
  };
  const PagesOrder = [
    PAGES.Account,
    PAGES.Slots,
    PAGES.Trips,
    PAGES.Operate,
    PAGES.Earnings,
  ];
  const [firstRender, setFirstRender] = useState(true);
  return (
    <FlowTransition
      pages={{
        [PAGES.Initial]: (props: FlowTrasitionParamsType) => (
          <MobileFirstPage
            {...props}
            slots={PAGES.Slots}
            account={PAGES.Account}
            trips={PAGES.Trips}
            earnings={PAGES.Earnings}
            operate={PAGES.Operate}
          />
        ),
        [PAGES.Account]: (props: FlowTrasitionParamsType) => (
          <FaqTab
            {...props}
            tab="Account"
            backPage={PAGES.Initial}
            initialQuestion={firstRender ? initialQuestion : undefined}
            setFirstRender={() => setFirstRender(false)}
          />
        ),
        [PAGES.Slots]: (props: FlowTrasitionParamsType) => (
          <FaqTab
            {...props}
            tab="Slots"
            backPage={PAGES.Initial}
            initialQuestion={firstRender ? initialQuestion : undefined}
            setFirstRender={() => setFirstRender(false)}
          />
        ),
        [PAGES.Trips]: (props: FlowTrasitionParamsType) => (
          <FaqTab
            {...props}
            tab="Trips"
            backPage={PAGES.Initial}
            initialQuestion={firstRender ? initialQuestion : undefined}
            setFirstRender={() => setFirstRender(false)}
          />
        ),
        [PAGES.Operate]: (props: FlowTrasitionParamsType) => (
          <OperateTab
            {...props}
            backPage={PAGES.Initial}
            initialSubSection={initialSubSection}
            initialQuestion={initialQuestion}
            setFirstRender={() => setFirstRender(false)}
            firstRender={firstRender}
          />
        ),
        [PAGES.Earnings]: (props: FlowTrasitionParamsType) => (
          <FaqTab
            {...props}
            tab="Earnings"
            backPage={PAGES.Initial}
            initialQuestion={firstRender ? initialQuestion : undefined}
            setFirstRender={() => setFirstRender(false)}
          />
        ),
      }}
      firstPage={
        initialSection !== undefined
          ? PagesOrder[initialSection]
          : PAGES.Initial
      }
      indexPage={PAGES.Initial}
      isOpen={false}
    />
  );
};
export default Faq;
